import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'name'
})
export class NamePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!value || value === 'Default' || value === 'default') {
      return args || ''
    }
    if (typeof value === 'string') {
      return value;
    }

    if (value.length) {
      let name = '';
      value.forEach(element => {
        name = `${element.name}|${name}`
      });

      return name.substr(0, name.length - 1)
    }
    return value.name || '';
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/pipes/name.pipe.ts